module.exports = __webpack_public_path__ + "assets/img/station11.5ab5f284.png";